import dynamic from 'next/dynamic';
import {
  Section,
  SectionContent
} from '@/vdp/AboutThePrice/AboutThePrice.styles';
import { useShowKBBPromo } from '@/vdp/StickyBanner/hooks';
import { SectionHeader } from '@/vdp/styles';
import Sections from '~/constants/vdp/sections';
import { useGetCkPromoFromDiscountContext } from '~/hooks/common/creditKarmaPromo';
import { useGetShowEVTaxTreatment, usePriceDrop } from '~/hooks/vdp';

const CreditKarmaPromoCard = dynamic(
  () =>
    import(
      /* webpackChunkName: "CreditKarmaPromoCard" */ '@/common/CreditKarmaPromoCard'
    )
);

const GreatDeal = dynamic(
  () => import(/* webpackChunkName: "GreatDeal" */ './GreatDeal')
);

const CleanTaxSavingsCard = dynamic(
  () =>
    import(/* webpackChunkName: "EvTaxCreditCard" */ './CleanTaxSavingsCard')
);

const NewPriceCard = dynamic(
  () =>
    import(/* webpackChunkName: "NewPriceCard" */ '@/vdp/NewPrice/NewPriceCard')
);

const AboutThePrice = () => {
  const showKBBPromo = useShowKBBPromo();
  const { showPriceDrop } = usePriceDrop();
  const showEVTaxTreatment = useGetShowEVTaxTreatment();
  const { shouldShowCkPromo, creditKarmaPromoAmount, expirationDate } =
    useGetCkPromoFromDiscountContext();

  return (
    <Section id={Sections.AboutThePrice}>
      <SectionHeader>About the Price</SectionHeader>
      <div className="mx-auto w-full max-w-[1144px] px-2xl xl:px-0">
        <SectionContent>
          {shouldShowCkPromo && (
            <CreditKarmaPromoCard
              creditKarmaPromoAmount={creditKarmaPromoAmount}
              expirationDate={expirationDate}
              variant="vdp"
            />
          )}
          {showPriceDrop && <NewPriceCard />}
          {showEVTaxTreatment && <CleanTaxSavingsCard />}
          {showKBBPromo && <GreatDeal />}
        </SectionContent>
      </div>
    </Section>
  );
};

export default AboutThePrice;
